// Library Methods
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Footer from "../../navigation/Footer/Footer";
import Navbar from "../../navigation/Navbar/Navbar";

// Contexts
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

// Utils
import { getLanguageCode } from "src/utils/locale/localeHelper";

const PortalLayout = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { clinicInfo, allClinicInfo, isLoading } = useClinicContext();

  // set site language when clinic changes
  useEffect(() => {
    if (clinicInfo) {
      const languageCode = getLanguageCode(
        clinicInfo?.settings?.clinicDefaultLanguage
      );

      // Only change the language if it is actually different
      // Otherwise all of the t() calls have to update, which causes lag
      if (languageCode !== i18n.language) {
        i18n.changeLanguage(languageCode);
      }
    }
  }, [i18n, clinicInfo]);

  // redirect to invalid route if no clinics exist for the user
  useEffect(() => {
    if (!isLoading && !allClinicInfo?.length) {
      navigate("/invalid");
    }
  }, [navigate, allClinicInfo?.length, isLoading]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar canNavigate={allClinicInfo?.length > 0} />
      <Outlet />
      <Footer />
    </Box>
  );
};

export default PortalLayout;
